// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3dF9h","upload":"Small_upload__r3vrq","imageWrap":"Small_imageWrap__2u_Ua","removeBtn":"Small_removeBtn__34NaR"};